"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Render3DGameObject = void 0;
var realms_engine_1 = require("realms-engine");
var utils_1 = require("./utils");
var realms_three_1 = __importDefault(require("realms-three"));
var realms_three_utils_1 = require("realms-three-utils");
/**
 * Renders a threejs object. Adding another Render3DGameObject as a child will automatically
 * add is as threejs child also
 */
var Render3DGameObject = /** @class */ (function (_super) {
    __extends(Render3DGameObject, _super);
    function Render3DGameObject(threeObject) {
        if (threeObject === void 0) { threeObject = new realms_three_1.default.Object3D(); }
        var _this = _super.call(this) || this;
        _this.threeObject = threeObject;
        _this.render3DChildren = new Set();
        _this.offset = (0, realms_engine_1.vector3Zero)();
        _this.outline = false;
        return _this;
    }
    Render3DGameObject.prototype.setThreeObject = function (threeObject) {
        var e_1, _a, e_2, _b;
        var renderChildren = Array.from(this.render3DChildren.values());
        try {
            // Remove all children from current three object
            for (var renderChildren_1 = __values(renderChildren), renderChildren_1_1 = renderChildren_1.next(); !renderChildren_1_1.done; renderChildren_1_1 = renderChildren_1.next()) {
                var child = renderChildren_1_1.value;
                this.removeChild(child);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (renderChildren_1_1 && !renderChildren_1_1.done && (_a = renderChildren_1.return)) _a.call(renderChildren_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var parent = this.getParent();
        if (parent instanceof Render3DGameObject) {
            parent.removeChild(this);
        }
        this.threeObject = threeObject;
        if (parent instanceof Render3DGameObject) {
            parent.addChild(this);
        }
        try {
            for (var renderChildren_2 = __values(renderChildren), renderChildren_2_1 = renderChildren_2.next(); !renderChildren_2_1.done; renderChildren_2_1 = renderChildren_2.next()) {
                var child = renderChildren_2_1.value;
                this.addChild(child);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (renderChildren_2_1 && !renderChildren_2_1.done && (_b = renderChildren_2.return)) _b.call(renderChildren_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.dispatch("onThreeObjectChange", this.threeObject);
    };
    Render3DGameObject.prototype.getThreeObject = function () {
        return this.threeObject;
    };
    Render3DGameObject.prototype.addChildRender3DGameObject = function (child) {
        this.render3DChildren.add(child);
    };
    Render3DGameObject.prototype.removeChildRender3DGameObject = function (child) {
        this.render3DChildren.delete(child);
    };
    /*
     * Add to the root of THREE.Scene.
     * This should be called automatically by Render3DSystem so don't use this
     * method unless you know what you are doing
     */
    Render3DGameObject.prototype.addToScene = function (scene) {
        var parent = this.getParent();
        if (parent instanceof Render3DGameObject) {
            parent.threeObject.add(this.threeObject);
            parent.addChildRender3DGameObject(this);
        }
        else {
            scene.add(this.threeObject);
        }
    };
    /*
     * Remove from the THREE Scene.
     * This should be called automatically by Render3DSystem so don't use this
     * method unless you know what you are doing
     */
    Render3DGameObject.prototype.removeFromScene = function (scene) {
        var _a;
        var parent = this.getParent();
        if (parent instanceof Render3DGameObject) {
            parent.removeChildRender3DGameObject(this);
        }
        (_a = this.threeObject.parent) === null || _a === void 0 ? void 0 : _a.remove(this.threeObject);
    };
    /**
     * Returns the height of the object
     */
    Render3DGameObject.prototype.getHeight = function () {
        var bbox = this.getBBox();
        return bbox.max.y - bbox.min.y;
    };
    /*
     * Get the BBOX of the root gameObject
     */
    Render3DGameObject.prototype.getBBox = function () {
        return new realms_three_1.default.Box3().setFromObject(this.threeObject);
    };
    Render3DGameObject.prototype.getVisible = function () {
        return this.threeObject.visible;
    };
    Render3DGameObject.prototype.setVisible = function (v) {
        this.threeObject.visible = v;
    };
    Render3DGameObject.prototype.getPosition = function () {
        return (0, realms_engine_1.vector3Subtract)((0, utils_1.threeToVector3)(this.threeObject.position), this.offset);
    };
    Render3DGameObject.prototype.setPosition = function (v) {
        var actualPos = (0, realms_engine_1.vector3Add)(v, this.offset);
        this.threeObject.position.set(actualPos.x, actualPos.y, actualPos.z);
    };
    Render3DGameObject.prototype.getOffset = function () {
        return this.offset;
    };
    Render3DGameObject.prototype.setOffset = function (offset) {
        var basePosition = (0, realms_engine_1.vector3Subtract)((0, utils_1.threeToVector3)(this.threeObject.position), this.offset);
        this.offset = offset;
        this.setPosition(basePosition);
    };
    Render3DGameObject.prototype.getQuaternion = function () {
        return (0, utils_1.threeToQuat)(this.threeObject.quaternion);
    };
    Render3DGameObject.prototype.setQuaternion = function (q) {
        this.threeObject.quaternion.set(q.x, q.y, q.z, q.w);
    };
    Render3DGameObject.prototype.getRotation = function () {
        return {
            x: this.threeObject.rotation.x,
            y: this.threeObject.rotation.y,
            z: this.threeObject.rotation.z,
        };
    };
    Render3DGameObject.prototype.setRotation = function (rotation) {
        this.threeObject.rotation.set(rotation.x, rotation.y, rotation.z);
    };
    Render3DGameObject.prototype.getScale = function () {
        return (0, utils_1.threeToVector3)(this.threeObject.scale);
    };
    Render3DGameObject.prototype.setScale = function (v) {
        this.threeObject.scale.set(v.x, v.y, v.z);
    };
    Render3DGameObject.prototype.onRemove = function (scene) {
        _super.prototype.onRemove.call(this, scene);
        // Clean up
        (0, realms_three_utils_1.disposeThreeObject)(this.threeObject);
    };
    return Render3DGameObject;
}(realms_engine_1.GameObject));
exports.Render3DGameObject = Render3DGameObject;
